import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { initGA, isPrerender } from "./utils/ga";

const injectScript = (src: string, id: string, isAsync = true) => {
  if (document.getElementById(id)) return;
  const script = document.createElement("script");
  script.id = id;
  script.async = isAsync;
  script.src = src;
  document.head.appendChild(script);
};

if (!isPrerender()) {
  if (process.env.REACT_APP_ENABLE_ATS !== "false") {
    injectScript("https://anymind360.com/js/17540/ats.js", "ats-script");
  }
  initGA();
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
